
<template>
  <div :style="{paddingLeft: marginLeft + 'px'}">
      <table class="min-w-full divide-y divide-gray-200">
          <tbody v-if="showRoot" class="bg-white divide-y divide-gray-200">
              <tr 
                  class="cursor-pointer" 
                  :class="{'bg-gray-300': 'root' == documentsStore.getCurrentlySelectedFolderId}"
                  @click="documentsStore.setCurrentlySelectedFolderId('root')"
              >
                  <td class="px-3 py-4" colspan="7">..</td>
              </tr>
          </tbody>

          <draggable @change="changed" v-model="this.folder.content"  :item-key="(el)=>el.info.unique_id" tag="tbody">
              <template #item="{ element }">
                <tr class="movable w-full">
                  <td>
                     <FolderRow v-if="element.type == 'folder'" :folder="element" />
                     <DocumentRow v-else-if="element.type == 'document'" :document="element.info" /> 
                  </td>
                </tr>
              </template>
            </draggable>
        </table>
  </div>
</template>

  
<script>
  import draggable from "vuedraggable";
  import FolderRow from "./FolderRow.vue";
  import DocumentRow from "./DocumentRow.vue";
  import { mapStores } from "pinia";
  import { useDocumentsStore } from "../../stores/documentsStore";

  export default {
    name: "file-system-sortable-table",
    display: "File System Sortable Table",
    order: 8,
    components: {
      draggable,
      FolderRow,
      DocumentRow
    },
    props: {
      folder: {
        type: Object,
        required: true
      },
      showRoot: {
        type: Boolean,
        required: true,
        default: false
      },
    },
    computed: {
      ...mapStores(useDocumentsStore),
      marginLeft(){
        return this.folder.level * 20;
      },
      sortedContent(){
        return this.folder.content.sort((a, b) => b.display_order - a.display_order);
      }
    },
    data() {
      return {
        dragging: false,
      };
    },
    methods: {
      changed: function () {
        this.updateDisplayOrder();
        setTimeout( this.persistDisplayOrder, 200)
      },
      updateDisplayOrder: function () {
        this.folder.content.forEach(function (content, index) {
          content.display_order = index;
        })
      },
      persistDisplayOrder: function () {
        if(this.folder.content.length == 0){
          return;
        }
        this.documentsStore.updateFolderContentSortOrderApi(this.folder.info.id, this.folder.content)
      },
    },
  };
  </script>
  <style scoped>
  
  .movable:hover {
    cursor: grab;
  }
  
  .movable:active {
    cursor: grabbing;
  }
  </style>
  